import Company from './company'
import Service from './service'
import Newsroom from './newsroom'
import Question from './question'

export const routes = [
  {
    path: '/:locale([en]*)?',
    name: 'Main',
    component: () => import('@/views/main/Index'),
    meta: {
      sitemap: {
        loc: '/'
      }
    }
  },
  Company,
  {
    path: '/:locale([en]*)?/credo',
    name: 'Consult',
    component: () => import('@/views/company/credo/Index'),
    redirect: { name: 'ConsultInfo' },
    meta: {
      sitemap: {
        loc: '/credo'
      }
    },
    children: [
      {
        path: 'consult',
        name: 'ConsultInfo',
        component: () => import('@/views/company/credo/Consult'),
        meta: {
          language: false,
          parent: 'Consult'
        }
      },
      {
        path: 'form',
        name: 'ConsultForm',
        component: () => import('@/views/company/credo/Report'),
        meta: {
          language: false,
          parent: 'Consult'
        }
      }
    ]
  },
  Service,
  {
    path: '/:locale([en/]*)?/together/:category(\\d+)?',
    name: 'Writing',
    component: () => import('@/views/writing/Index'),
    meta: {
      scroll: true,
      // language: false,
      sitemap: {
        loc: '/together'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/together/:category?/detail/:writingId(\\d+)?',
    name: 'writingDetail',
    component: () => import('@/views/writing/Detail'),
    meta: {
      language: false,
      parent: 'Writing',
      sitemap: { ignoreRoute: true }
    }
  },
  Newsroom,
  {
    path: '/:locale([en/]*)?/report/detail/:newsroomId?',
    name: 'newsroomReportDetail',
    component: () => import('@/views/newsroom/ReportDetail'),
    meta: {
      language: false,
      parent: 'NewsroomReport',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/:locale([en/]*)?/fact/detail/:newsroomId?',
    name: 'newsroomFactDetail',
    component: () => import('@/views/newsroom/FactDetail'),
    meta: {
      language: false,
      parent: 'NewsroomFact',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/:locale([en/]*)?/fonts',
    name: 'Fonts',
    component: () => import('@/views/fonts/Index'),
    meta: {
      sitemap: {
        loc: '/fonts'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/fonts/license',
    name: 'FontsLicense',
    component: () => import('@/views/fonts/License'),
    meta: {
      language: false,
      parent: 'Fonts',
      sitemap: {
        loc: '/fonts/license'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/place',
    name: 'Place',
    component: () => import('@/views/place/Index'),
    meta: {
      sitemap: {
        loc: '/place'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/notice',
    name: 'Notice',
    component: () => import('@/views/notice/Index'),
    meta: {
      language: false,
      sitemap: {
        loc: '/notice'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/notice/detail/:noticeId(\\d+)?',
    name: 'NoticeDetail',
    component: () => import('@/views/notice/Detail'),
    meta: {
      language: false,
      parent: 'Notice',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/:locale([en/]*)?/policy/:id(\\d+)?',
    name: 'Policy',
    component: () => import('@/views/policy/Index'),
    meta: {
      language: false,
      sitemap: {
        loc: '/policy'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/personal-information/detail/:id(\\d+)?',
    name: 'PolicyShare',
    component: () => import('@/views/policy/Index'),
    meta: {
      language: false,
      sitemap: { ignoreRoute: true }
    }
  },
  Question,
  {
    path: '/clear',
    name: 'Clear',
    component: () => import('@/views/html/Clear'),
    meta: {
      language: false,
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/Error'),
    meta: {
      language: false,
      sitemap: { ignoreRoute: true }
    }
  }
]
